import createVueApp from '@phoenix/createVueApp';
import VerticalCluster from '@maison/components/organisms/slider/VerticalCluster.vue';

document.querySelectorAll('.phoenix-vertical-cluster').forEach((el) => {
  const app = createVueApp({}, true);
  app.component('VerticalCluster', VerticalCluster);
  app.mount(el);
});
